import { IDriversQuery } from '../interfaces/driver.interface';
import { PATHS } from '../const/paths.constants';
import { API } from './config-service.api';

export const resendInvitation = (userID: any) => API.post(`${PATHS.DRIVERS}/${userID}/resend-invitation`);

export const oldUpdateDriver = (payload: any) => API.put(`${PATHS.DRIVERS}/${payload._id}`, payload);

// New API
export const getDrivers = (query: IDriversQuery) => API.get(PATHS.DRIVERS, {
    params: query,
    paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach((v) => searchParams.append(key, v));
            } else if (value !== undefined && value !== null) {
                searchParams.append(key, String(value));
            }
        });
        return searchParams.toString();
    },
});

export const getDriverById = (id: string) => API.get(`${PATHS.DRIVERS}/${id}`);

export const addDriver = (payload: any, token: string) => API.post(PATHS.DRIVERS, payload, { headers: { Authorization: `Bearer ${token}` } });

export const updateDriver = (id: string, payload: any) => API.put(`${PATHS.DRIVERS}/${id}`, payload);

export const deleteDriver = (id: string, payload: { keyName: string }) => API.delete(`${PATHS.DRIVERS}/${id}`, { data: payload });

export const bulkImportDrivers = (payload: { drivers: any[] }, token: string) => API.post(`${PATHS.DRIVERS}/bulk`, payload, { headers: { Authorization: `Bearer ${token}` } });
